import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {
    doctor: [],
  },
  editData: [],
};

export const UserMasterFormSlice = createSlice({
  name: "UserMasterFormReducer",
  initialState,
  reducers: {
    setUserMasterData: (state, action) => {
      state.editData = action.payload;
    },
    setDoctorComboList: (state, action) => {
      state.filters.doctor = action.payload;
    },
    resetUserMaster: (state) => {
      state.editData = {};
    },
  },
});

export const { setUserMasterData, setDoctorComboList, resetUserMaster } =
  UserMasterFormSlice.actions;

export default UserMasterFormSlice.reducer;
